export default __webpack_public_path__ + "static/media/boomerang_swood.83ff50a4.svg";